import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  root: {
    width: "100%",
    height: "100%",
    overflow: "hidden",
    overflowY: "auto"
  },
  default: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    filter: "brightness(0.8)", //blur(1.5px)
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundColor: theme.palette.background.paper,
    zIndex: -100
  }
}));
